/**
 * Reusable small pie chart for the budget + tasks summary cards.
 * Encapsulates the rechart boilerplate so the card components stay clean.
 */
import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export default function SummaryPie({ filled, remaining, filledColor, remainingColor = '#CCC2BC' }) {
  return (
    <div className="w-28 h-28 flex-shrink-0">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={[
              { name: 'filled', value: filled || 0 },
              { name: 'remaining', value: Math.max(0, remaining || 0) },
            ]}
            cx="50%" cy="50%" innerRadius={30} outerRadius={45}
            paddingAngle={2} dataKey="value" startAngle={90} endAngle={-270}
          >
            <Cell fill={filledColor} />
            <Cell fill={remainingColor} />
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
